// ─── AI PLAYER CONFIGURATION ─────────────────────────────────────────────────
// Edit src/config/aiConfig.json to add new AI player names and sayings.
// They'll automatically appear in the game, game viewer, and get buck money accounts.

import config from './aiConfig.json';

export const AI_NAMES = config.AI_NAMES;
export const AI_PASS_SAYINGS = config.AI_PASS_SAYINGS;
export const AI_ORDER_SAYINGS = config.AI_ORDER_SAYINGS;
export const AI_NAMING_SAYINGS = config.AI_NAMING_SAYINGS;
export const AI_SIT_SAYINGS = config.AI_SIT_SAYINGS;
export const AI_PLAY_SAYINGS = config.AI_PLAY_SAYINGS;
